module.exports = __webpack_public_path__ + "static/media/fly0028.2ef9b0bc.webp";